import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCubeSvg } from "./IconCubeSvg.mjs";
const IconCube = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCubeSvg, ...iconProps });
};
export {
  IconCube
};
